import React from "react";
import { BuyingProfileIcon, ContactIcon } from "./svg-icons";
import { useFormContext } from "./context/FormContext";
import { cn } from "@/lib/utils";

const FormProgressIndicator = () => {
  const { step } = useFormContext();

  return (
    <div className="mb-8 flex items-end sm:mb-12 sm:items-center">
      <div className="flex flex-col items-start gap-0 sm:flex-row sm:items-center sm:gap-2">
        <span>
          <ContactIcon strokeColor="#FBFBFB" />
        </span>
        <p className="mt-1 text-sm leading-none text-system-disabled sm:text-[15px]">
          Contact information
        </p>
      </div>

      <div className="mx-4 mb-2 flex items-center sm:mb-0">
        <div className="h-[1px] w-[40px] bg-system-disabled sm:w-[72px]"></div>
      </div>
      <div className="flex flex-col items-start gap-0 sm:flex-row sm:items-center sm:gap-2">
        <span>
          <BuyingProfileIcon strokeColor={step !== "contact" ? "#FBFBFB" : "#61646C"} />
        </span>
        <p
          className={cn(
            step !== "contact" ? "text-system-disabled" : "text-system-steel",
            "mt-1 text-sm leading-none sm:text-[15px]"
          )}
        >
          Buying profile
        </p>
      </div>
    </div>
  );
};

export default FormProgressIndicator;
